import React from "react";

const Hero = () => {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-black">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src="/broker-mclean.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/10 to-black/45" />

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/70">
        <span className="text-[10px] tracking-luxe uppercase">Scroll</span>
        <div className="w-px h-10 bg-white/30 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-white" style={{ animation: "scrollLine 2s ease-in-out infinite" }} />
        </div>
      </div>
      <style>{`@keyframes scrollLine {0%{transform:translateY(-100%);}100%{transform:translateY(200%);}}`}</style>
    </section>
  );
};

export default Hero;
